import User from "@skrice.studio/mavia-common/build/models/main/User";
import ChatMessage from "@skrice.studio/mavia-common/build/models/messages/ChatMessage";
import { Alert, Button } from "@mui/material";
import axios from "axios";
import * as React from "react";
import CustomScroll from "react-customscroll";
import { NavLink } from "react-router-dom";
import { Avatar } from "../../components/Avatar";
import { Config } from "../../config/config";
import { Helpers } from "../../utils/helpers";
import { PopupMessage } from "../../utils/message";
import { DefaultProps } from "../LayoutWrapper";

const CustomScrollWrapped: any = CustomScroll;

interface Props extends DefaultProps {
    allianceId: string
    members: User[];
}

interface State {
    history: ChatMessage[];
    loaded: boolean;
    latestMessage: null | string;
    allLoaded: boolean;
}

export class AllianceChatHistory extends React.Component<Props, State> {
    constructor(props) {
        super(props);

        this.state = {
            history: [],
            loaded: false,
            latestMessage: null,
            allLoaded: false,
        }
    }

    componentDidMount() {
        this.fetchData();
    }

    async fetchData() {
        try {
            const response = await axios.get(
                `${Config.getInstance.apiUrl}/api/alliances/${this.props.allianceId}/chat_history/${this.state.latestMessage}`,
                {
                    headers: {
                        Authorization: Helpers.getSessionId(),
                    },
                },
            );

            const allLoaded = response.data.length === 0;

            this.setState({
                ...(!allLoaded && {
                    history: [...this.state.history, ...response.data],
                    latestMessage: response.data[response.data.length - 1].created_at,
                }),
                allLoaded,
                loaded: true,
            });
        } catch (e) {
            PopupMessage.error("Failed to load chat history: " + e.message);
        }
    }

    getMessage(item: ChatMessage) {
        if (item.translatable) {
            return Helpers.getLocalizationName(item.message, item.metadata);
        }

        return item.message;
    }

    getUser(item: ChatMessage) {
        const poster = this.props.members.find(member => member.id === item.user_id) || item?.metadata?.user || null;

        if (!poster) {
            return null;
        }

        return <div className="user--wrapper">
            {Avatar(poster)}

            <span className="username">
                <NavLink to={`/players/${poster.id}`}>
                    {poster.name}
                </NavLink>
            </span>
        </div>
    }

    render() {
        const chatMessagesCount = (this.state.history || []).length;

        return <React.Fragment>
            {chatMessagesCount > 0 && <div className="chat-history">
                <CustomScrollWrapped>
                    {(this.state.history || []).map(item => <div className={`chat-item ${item.action}`}>
                        {item.action === "message" && <div className="user">{this.getUser(item)}</div>}
                        <div className="message">
                            {this.getMessage(item)}
                            <div className="date">{Helpers.formatTimeAgo(item.created_at)}</div>
                        </div>
                    </div>)}
                </CustomScrollWrapped>
            </div>}

            {chatMessagesCount === 0 && <Alert severity="info">No Chat History Found</Alert>}

            {!this.state.allLoaded && <Button
                disableElevation
                size="small"
                color="primary"
                variant="contained"
                style={{ marginTop: 25, width: "100%" }}
                onClick={() => this.fetchData()}
            >
                Load more
            </Button>}
        </React.Fragment>
    }
}
